import { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import Button from 'components/shared/Button';
import Modal from 'components/shared/Modal';
import ReactPortal, { useReactPortal } from 'components/shared/ReactPortal';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { itinerariesItemIdSelector } from 'store/itinerariesItem/selectors';

import { MOBILE_WARNING_NAME } from './constants';
import s from './index.module.css';

function MobileWarningWrapper({ children }: any) {
  const [isOpen, setIsOpen] = useState(false);
  const internalPortal = useReactPortal({ wrapperId: 'internal-modal' });
  const { isTabletOrMobile } = useMediaBreakpoints();
  const itemId = useSelector(itinerariesItemIdSelector);
  const itemWarningName = MOBILE_WARNING_NAME + itemId;

  const toClose = () => {
    setIsOpen(false);
    localStorage.setItem(itemWarningName, 'true');
  };

  useEffect(() => {
    const isMobileWarningRead = localStorage.getItem(itemWarningName);

    if (isMobileWarningRead !== 'true') {
      setIsOpen(true);
    }
  }, []);

  if (!isTabletOrMobile) return children;

  return (
    <>
      <ReactPortal {...internalPortal}>
        {/*@ts-ignore*/}
        <Modal contentClassName={s.modal} isOpen={isOpen} toClose={toClose}>
          <div>
            <div className={s.header}>
              {/*@ts-ignore*/}
              <FormTitle className={s.title}>Heads Up!</FormTitle>
            </div>
            <div className={s.content}>
              <Text accent size="large">
                Calendar View is only available on desktop
              </Text>
            </div>
            <div className={s.footer}>
              <Button size="large" onClick={toClose}>
                Got it
              </Button>
            </div>
          </div>
        </Modal>
      </ReactPortal>

      {children}
    </>
  );
}

export default MobileWarningWrapper;
